module.exports = __webpack_public_path__ + "static/media/MariaRebecaFelixRuiz.07080cbb.jpg";